<template>
  <div :class="{ 'invalid': isInvalid }">
    <multiselect v-model="poolsOfCandidate"
                 :options="getCustomers"
                 :multiple="true"
                 :close-on-select="false"
                 :clear-on-select="false"
                 noResult="Geen bedrijven gevonden"
                 selectLabel=""
                 deselectLabel=""
                 selectedLabel=""
                 @input="updateSelected"
                 :preserve-search="true" placeholder="Selecteer bedrijven" label="name" track-by="id" :preselect-first="false">
      <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single"
                                                                               v-if="!isOpen">{{values.length}} {{
          values.length === 1 ? 'bedrijf' : 'bedrijven'
        }} geselecteerd</span></template>
    </multiselect>
    <label class="typo__label form__label" v-show="isInvalid">Je moet minstens één bedrijf kiezen</label>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import {mapGetters} from "vuex";

export default {
  props: [ 'candidateId', 'isInvalid'],
  components: {
    Multiselect
  },
  data() {
    return {
      selectedUnsavedPools: [],
      changedMade: false,
      value: [],
      options: [
        {name: 'Vue.js', language: 'JavaScript'},
        {name: 'Adonis', language: 'JavaScript'},
        {name: 'Rails', language: 'Ruby'},
        {name: 'Sinatra', language: 'Ruby'},
        {name: 'Laravel', language: 'PHP'},
        {name: 'Phoenix', language: 'Elixir'}
      ]
    }
  },
  methods: {
    async updateSelected(updatedArray) {
      const original = this.getPoolsOfCandidateId(this.candidateId);
      this.$emit('poolsChanged', {
        added: _.filter(updatedArray, item => {
          return !_.filter(original, {'customerId': item.id, 'archived': false }).length;
        }),
        removed: _.filter(_.filter(original, {'archived': false}), item => {
          return !_.filter(updatedArray, {'id': item.customerId }).length;
        })
      });
    },
    resetPoolChanges() {
      this.selectedUnsavedPools = [];
      this.changedMade = false;
    }
  },
  computed: {
    ...mapGetters('customers', ['getCustomers']),
    ...mapGetters('pools', ['getPoolsOfCandidateId']),
    poolsOfCandidate: {
      get() {
        if (!this.selectedUnsavedPools.length && !this.changedMade) {
          this.selectedUnsavedPools = _.map(_.filter(this.getPoolsOfCandidateId(this.candidateId), {'archived': false}), pool => {
            return _.find(this.getCustomers, {id: pool.customerId })
          });
        }
        return this.selectedUnsavedPools;
      },
      set (value) {
        this.changedMade = true;
        this.selectedUnsavedPools = value;
      }
    },
  },
  watch: {
    getPoolsOfCandidateId: {
      handler(newV, oldV) {
        this.values = newV;
      }
    }
  }
}
</script>
<style>
.invalid .multiselect__tags {
  border-color: #f04124!important;
}

.invalid .typo__label {
  color: #f04124;
}

</style>